import './HomePage.scss'
import React, { useState, useEffect } from 'react'
import navLogo from '../assets/img/nav_logo.png'
import screenshot from '../assets/img/background.png'
import icon from '../assets/img/icon.png'
import qrcode from '../assets/img/qrcode.png'
import scan from '../assets/img/scan.png'

function HomePage () {
    const [scrolling, setScrolling] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolling(true)
            } else {
                setScrolling(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const handleMouseEnter = () => {
        setIsHovered(true)
    }

    const handleMouseLeave = () => {
        setIsHovered(false)
    }

    const handleLinkClickToTerms = () => {
        window.open('https://speaktypekeyboard.geniustech.ai/user-agreement/terms_of_use.html', '_blank')
    }

    const handleLinkClickToPrivate = () => {
        window.open('https://speaktypekeyboard.geniustech.ai/user-agreement/privacy_policy.html', '_blank')
    }

    const handleLocateToAppStore = () => {
        window.open('https://apps.apple.com/us/app/voicelingo-keyboard/idYOUR_APP_ID', '_blank')
    }

    const handleContactSupport = () => {
        const recipient = 'speaktype.support@geniustech.ai'
        const subject = 'Feedback'
        const body = 'Please describe your issue here...'
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        window.open(mailtoLink)
    }

    return (
        <div className="App">
            <header className={scrolling ? "header header-scrolled" : "header"}>
                <div className='container'>
                    <div className='navL'>
                        <img src={navLogo} alt="SpeakType Keyboard" style={{ width: '300px' }} />
                    </div>
                    <div className='navR'>
                        {/* 临时隐藏，等产品上线后再启用 */}
                        <div className='store' onClick={handleLocateToAppStore} style={{ display: 'none' }}>App Store</div>
                        <div
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}

                            style={{ backgroundColor: isHovered ? '#171717' : '#171717', display: 'none' }}
                            className='download'>
                            Download
                            {isHovered && (
                                <div className='qrCode'>
                                    <div className='triangle'>
                                        <img src="./triangle.png" alt="" />
                                    </div>
                                    <div className='qrcode'>
                                        <img src={qrcode} alt="" />
                                    </div>
                                    <div className='text'>
                                        <div>
                                            <img src={scan} alt="" />
                                        </div>
                                        <div>Scan to download</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div className='section'>
                <div className='left'>
                    <img src={screenshot} alt="" />
                </div>
                <div className='right'>
                    <div className='icon'>
                        <img src={icon} alt="" />
                    </div>
                    <div className='name'>SpeakType Keyboard</div>
                    <div className='desc'>
                        Transform your typing experience with AI-powered voice keyboard. Speak naturally and let AI convert your voice to text with high accuracy. SpeakType Keyboard intelligently processes your voice input, providing real-time transcription and enabling smart text editing. Get instant voice-to-text conversion, support multiple languages, and enhance your productivity with hands-free typing.
                    </div>
                    <div className='contact'>
                        For inquiries or support, contact email: <a href="mailto:speaktype.support@geniustech.ai">speaktype.support@geniustech.ai</a>
                    </div>
                </div>
            </div>
            <footer className='footer'>
                <div className='container'>
                    <div className='footerL'>
                        <div className='title'>SpeakType Keyboard</div>
                        <div className='copyright'>2026 © GENIUS AI LABS PTE. LTD. All Rights Reserved.</div>
                    </div>
                    <div className='footerR'>
                        <div className='item'>
                            <a href='https://speaktypekeyboard.geniustech.ai/user-agreement/privacy_policy.html' target='_blank' rel='noreferrer'>
                                Privacy Policy
                            </a>
                        </div>
                        <div className='item'>
                            <a href="https://speaktypekeyboard.geniustech.ai/user-agreement/terms_of_use.html" target='_blank' rel='noreferrer'>
                                Terms of Use
                            </a>
                        </div>
                        <div className='item'>
                            <div className='link'
                                onClick={handleContactSupport}
                            >Email
                                <span style={{ color: "#FFFFFF66", marginLeft: "10px", fontSize: "12px" }}>
                                    speaktype.support@geniustech.ai
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default HomePage;

